import React from 'react';
import NavBar from 'shared/NavBar/NavBar';
import { Container } from '@material-ui/core';
import { useSelector } from 'react-redux';
import Footer from 'shared/Footer/Footer';
import EnvironmentBannerConnection from 'screens/Panel/components/EnvironmentBanner/EnvironmentBannerConnection';

const DefaultTemplate: React.FC<any> = ({ children }) => {
  const { containerWidth } = useSelector((state: any) => state.layouts);

  return (
    <>
      <header>
        <NavBar />
        <EnvironmentBannerConnection />
      </header>
      <main>
        <Container maxWidth={containerWidth} className="container">
          {children}
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default DefaultTemplate;
